module.exports = __webpack_public_path__ + "1792395595471/images/north-america.ac4661b.png";